module.exports = __webpack_public_path__ + "static/media/scrum5.4b202515.png";